import { LoadableLazy } from '@confluence/loadable';

export const ChangesDiffLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ChangesDiff" */ './ChangesDiff.tsx')).ChangesDiff,
});
